import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Nullable, Optional } from '../../shared/shared.types';

@Injectable({
  providedIn: 'root',
})
export class CustomerDataStorageService {
  private static readonly PROFILE_KEY = 'CustomerData';
  private readonly storage: StorageService = inject(LOCAL_STORAGE);

  public getCustomerData(): CustomerData {
    return this.storage.get(CustomerDataStorageService.PROFILE_KEY);
  }

  public setCustomerData(customerData: CustomerData) {
    this.storage.set(CustomerDataStorageService.PROFILE_KEY, customerData);
  }

  public remove() {
    this.storage.remove(CustomerDataStorageService.PROFILE_KEY);
  }
}

export interface CompanyData {
  name: string;
  taxId?: Optional<string>;
}

export interface AddressOverviewData {
  salutation?: Nullable<string>;
  companyName?: Nullable<string>;
  givenName: string;
  familyName: string;
  street: string;
  houseNr: string;
  addressSupplement?: Nullable<string>;
  zipCode: string;
  city: string;
  country: string;
}

export interface CustomerData {
  customerNumber: string;
  company?: Nullable<CompanyData>;
  shippingAddress?: Nullable<AddressOverviewData>;
}
